import moment from "moment";
import { useMemo } from "react";
import { Typography } from "@mui/material";

type JoinByDateProps = {
  joinByDate?: string;
  deadlineTime?: string;
};

function JoinByDate({ joinByDate = "", deadlineTime }: JoinByDateProps) {
  const leftToJoin = useMemo(() => {
    if (!joinByDate || !moment(joinByDate)?.isValid()) return null;
    const jbd = deadlineTime
      ? moment(`${joinByDate} ${deadlineTime}`, "YYYY-MM-DD HH:mm:ss")
      : moment(joinByDate).add(1, "day");
    const now = moment();

    const duration = moment.duration(jbd.diff(now));

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    const leftToJoinText = <span>{`${days}d, ${hours}h`}</span>;
    return leftToJoinText;
  }, [deadlineTime, joinByDate]);

  if (!leftToJoin) return null;

  return (
    <div className=" d-flex flex-column align-items-start">
      <Typography
        variant="body1"
        className="fw-b"
        color="text.primary"
        style={{ lineHeight: "0.9" }}
      >
        {leftToJoin}
      </Typography>
      <Typography variant="caption" color="var(--neutral-600)">
        Left to join
      </Typography>
    </div>
  );
}

export default JoinByDate;
